import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list'
import FullCalendar from '@fullcalendar/react'
import timeGridPlugin from '@fullcalendar/timegrid'
import { Pagination } from '@mui/material'
import { BackpackIcon, Cross2Icon } from '@radix-ui/react-icons'
import { MoreHorizontal } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { NavLink } from 'react-router-dom'
import { checkTagValidity } from '../../Utils/Utils'
import { DELETE_PLANING, DISABLE_TEAM, LIST_PLANING, LIST_TEAM } from '../../Utils/constant'
import { PlaningForm } from '../../components/Planing/PlaningForm'
import { PlaningFormUpdate } from '../../components/Planing/PlaningFormUpdate'
import { Loader } from '../../components/Widget/Loader'
import { Tabs } from '../../components/Widget/Tab'
import { AddTeam } from '../../components/utilisateur/AddTeam'
import { UpdateTeam } from '../../components/utilisateur/UpdateTeam'
import { deleteOne, disable } from '../../services/service'
import { useGlobalStore } from '../../store/store'
import { useStoreApp } from '../../store/storeApp'

export const Planing = () => {
    const planing = useGlobalStore()
    const [item, setItem] = useState(null)
    const [active, setActive] = useState({
        index: 0,
        value: "Gestion d'equipe",
        label: ""
    })

    const filteredTabsData = [
        {
            index: 0,
            value: "Gestion d'equipe",
            label: ""
        },
        {
            index: 1,
            value: 'Planification',
            label: ''
        }
    ]

    const equipe = useStoreApp()

    useEffect(() => {
        equipe.getData(LIST_TEAM, { page: 0, param: "", size: 10 }, '')
        planing.getData(LIST_PLANING)
    }, [])
    const calendarOptions = {
        events: planing?.data,
        plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin],
        initialView: 'dayGridMonth',
        locale: 'fr',
        buttonText: {
            month: 'mois',
            week: 'semaine',
            day: 'jour',
            list: 'liste'
        },
        headerToolbar: {
            start: 'prev, next, title',
            end: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth'
        },
        views: {
            week: {
                titleFormat: { year: 'numeric', month: 'long', day: 'numeric' }
            }
        },

        editable: true,

        eventClick({ event }) {
            setItem(event._def);
            document.getElementById('my_modal_3').showModal()
        },

        customButtons: {
            sidebarToggle: {
                icon: 'bi bi-list',
                click() {

                }
            }
        },

        dateClick(info) {
        },
    }

    const more = async (page) => {
        equipe.getData(LIST_TEAM, { page: page - 1, param: "", size: 10 }, '')
    }

    return (
        <div className=''>
            <dialog id="delete" className="modal">
                <div className="modal-box max-w-md rounded-lg">
                    <h3 className="font-extrabold text-xl text-red-600 ">
                        Attention
                    </h3>
                    <p className="pt-2 text-black font-medium">
                        Voulez vous vraiment effectuer cette action ?
                    </p>
                    <div className="modal-action">
                        <form
                            method="dialog"
                            className="w-full flex items-center justify-end gap-x-4"
                        >
                            <button id='close_delete' className="bg-gray-100 text-gray-600 w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                                Annuler
                            </button>
                            <button onClick={() => {
                                console.log(item);
                                deleteOne(DELETE_PLANING, item?.publicId).then(() => {
                                    document.getElementById('close').click()
                                    document.getElementById('close_delete').click()
                                    planing.getData(LIST_PLANING)
                                    toast.success('Planing supprimé')
                                }).catch((err) => {

                                })
                            }} className="bg-red-600 text-white w-fit h-10 px-4 rounded-md flex items-center justify-center font-semibold">
                                Suppirmer
                            </button>
                        </form>
                    </div>
                </div>
            </dialog>

            <dialog id="my_modal_3" className="modal">
                <div className="modal-box lg:w-96">
                    <form method="dialog">
                        <button id='close' className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
                    </form>
                    <ul className="menu dropdown-content bg-base-100">
                        <li onClick={() => {
                            // document.getElementById('close').click()
                            document.getElementById('edit_planing').showModal()
                        }}><a>Modifier la planification</a></li>
                        <li onClick={() => {
                            document.getElementById('delete').showModal()
                        }} className='hover:bg-red-100 hover:rounded hover:text-red-700 text-red-700 font-medium'><a>Supprimer la planification</a></li>
                    </ul>
                </div>
            </dialog>
            <Tabs tabsData={filteredTabsData} active={active} setActive={setActive} />
            {
                active.index === 0 ?
                    <>
                        <h3 class="font-mtn text-3xl font-bold mt-12">
                            Gestion d'equipe
                        </h3>
                        <div className='flex items-center'>
                            <input onChange={(e) => {
                                equipe.getData(LIST_TEAM, { page: 0, param: e.target.value, size: 10 }, '')
                            }} type="text" placeholder="Recherche..." className="input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
                            />
                            <button onClick={() => {
                                setActive({
                                    index: 0,
                                    filter: "TECHNICIEN",
                                    value: 'Equipes',
                                })
                                document.getElementById('add_Team').showModal()
                            }
                            } className="ml-auto btn btn-sm bg-main rounded-md text-black text-xs hover:bg-gray-900 hover:text-white" >
                                Ajouter une equipe
                            </button>
                        </div>
                        <dialog id="add_Team" className="modal rounded-none">
                            <div className="modal-box w-10/12 max-w-xl h-3/5">
                                <div className="modal-action">
                                    <h1 className='mr-auto text-2xl font-bold font-mtn'>
                                        Ajouter une equipe
                                    </h1>
                                    <form method="dialog">
                                        <button id='close_team' className="btn btn-sm"><Cross2Icon /></button>
                                    </form>
                                </div>
                                <AddTeam />
                            </div>
                        </dialog>
                        <div className='grid md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-5 2xl:grid-cols-5 gap-2 my-8'>
                            {
                                equipe?.data?.data?.length === 0 ? '' : equipe?.data?.data?.length !== 0 && !equipe?.loading ? (
                                    equipe?.data?.data?.map((item) => (
                                        <div className='py-2 relative flex gap-1 items-center cursor-pointer text-black shadow-sm border bg-white  rounded text-xs'>
                                            <div className="dropdown dropdown-end absolute right-2 top-2">
                                                <div
                                                    tabIndex={0}
                                                    role="button"
                                                    className="w-4 h-4 rounded-full flex items-center justify-center bg-gray-50"
                                                >
                                                    <MoreHorizontal size={20} />
                                                </div>
                                                <ul
                                                    tabIndex={0}
                                                    className="mt-1 dropdown-content z-[1] menu p-2 border shadow bg-base-100 rounded-lg w-44"
                                                >
                                                    <NavLink to={`equipe/detail-equipe/${item?.equipe?.id}/${item?.equipe?.designation}`}
                                                        className="bg-white hover:bg-gray-100 text-gray-600 font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                                                    >
                                                        Les techniciens
                                                    </NavLink>
                                                    <button
                                                        onClick={() => {
                                                            document.getElementById(`update_Team${item?.equipe?.id}`).showModal()
                                                        }}
                                                        className="bg-white hover:bg-gray-100 text-gray-600 font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                                                    >
                                                        Modifier
                                                    </button>

                                                    <dialog id={`update_Team${item?.equipe?.id}`} className="modal rounded-none">
                                                        <div className="modal-box w-10/12 max-w-xl">
                                                            <div className="modal-action">
                                                                <h1 className='mr-auto text-2xl font-bold font-mtn'>
                                                                    Modification d'une equipe
                                                                </h1>
                                                                <form method="dialog">
                                                                    <button id='close' className="btn btn-sm"><Cross2Icon /></button>
                                                                </form>
                                                            </div>
                                                            <UpdateTeam item={item} />
                                                        </div>
                                                    </dialog>

                                                    <button
                                                        onClick={() => {
                                                            disable(DISABLE_TEAM, item?.equipe?.id).then((res) => {
                                                                if (res.status === 200) {
                                                                    equipe.getData(LIST_TEAM, { page: 0, param: '', size: 10 }, '')
                                                                    toast.success(res.data.donnee)
                                                                }
                                                            })
                                                        }
                                                        }
                                                        className="bg-white hover:bg-red-600 text-black hover:text-white font-semibold h-9 w-full flex items-center justify-start rounded-lg px-3"
                                                    >
                                                        {item?.equipe?.isActif ? 'Desactiver' : 'Activer'}
                                                    </button>
                                                </ul>
                                            </div>
                                            <div className='bg-amber-200 w-10 h-10 rounded m-1 flex items-center justify-center'>
                                                <BackpackIcon />
                                            </div>
                                            <div className=''>
                                                <p className='truncate w-28'>{item?.equipe?.designation}</p>
                                                <p className='flex items-center mt-1 '>Techniciens : {item?.listTechnicien?.length}</p>
                                                <p className={`w-fit px-2 border rounded-full ${item?.equipe?.isActif ? 'text-green-600' : 'text-red-600'}`}> {item?.equipe?.isActif ? 'Actif' : 'Inactif'}</p>
                                            </div>
                                        </div>
                                    ))
                                ) :
                                    <Loader />
                            }
                        </div>
                        {
                            <div className='my-3 flex justify-end'>
                                {active ?
                                    <Pagination onChange={(event, newValue) => more(newValue)}
                                        onSelect={selectedPage => more(selectedPage)} count={equipe?.data?.totalPages} variant="outlined" color='primary' shape="rounded" /> : null}
                            </div>
                        }
                    </>

                    :
                    <>
                        <div className='mt-2 flex items-center'>
                            <h3 class="font-mtn text-3xl font-bold">
                                Planing d'equipe
                            </h3>

                            <div className='ml-auto flex items-center gap-2'>
                                {
                                    checkTagValidity('AJOUTER_PLANNING') ?
                                        <button
                                            onClick={() => {
                                                document.getElementById('planing').showModal()
                                            }}
                                            className="btn btn-sm h-10 hover:bg-[#ffcb05] bg-[#ffcb05] "
                                        >
                                            Faire une planification
                                        </button>
                                        :
                                        null
                                }
                                <dialog id="planing" className="modal rounded-none">
                                    <div className="modal-box w-10/12 max-w-xl h-[450px]">
                                        <div className="modal-action">
                                            <h1 className='font-mtn mr-auto text-2xl font-bold'>
                                                Planification par equipe
                                            </h1>
                                            <form method="dialog">
                                                <button id='planing_form' className="btn btn-sm"><Cross2Icon /></button>
                                            </form>
                                        </div>
                                        <div>
                                            <PlaningForm />
                                        </div>
                                    </div>
                                </dialog>

                                <dialog id="edit_planing" className="modal rounded-none">
                                    <div className="modal-box w-10/12 max-w-xl h-[450px]">
                                        <div className="modal-action">
                                            <h1 className='font-mtn mr-auto text-2xl font-bold'>
                                                Modifier le planing de quipe
                                            </h1>
                                            <form method="dialog">
                                                <button id='fermer' className="btn btn-sm"><Cross2Icon /></button>
                                            </form>
                                        </div>
                                        <div>
                                            <PlaningFormUpdate item={item} />
                                        </div>
                                    </div>
                                </dialog>
                            </div>
                        </div>

                        <div className='my-4 font-mtn bg-white p-3 rounded'>
                            <FullCalendar
                                themeSystem='Journal'
                                {...calendarOptions}
                            />
                        </div>
                    </>
            }




        </div>
    )
}
